import React, { Component } from 'react';
import { func, string } from 'prop-types';
import './SalaryRangeHeader.scss';

class SalaryRangeHeader extends Component {
  static propTypes = {
    closeSlideout: func,
    jobCodeKey: string,
    title: string
  };

  render() {
    const { closeSlideout, jobCodeKey, title } = this.props;

    return (
      <div className="salary__range-header">
        <div className="left__header-panel">
          <div className="salary__range-title">Assign Market Data Points</div>
          <div className="salary__range-job">
            <div className="details__section">
              Job Code
              <span className="details__data-item">{jobCodeKey}</span>
            </div>
            <div className="details__section">
              Job Title
              <span className="details__data-item">{title}</span>
            </div>
          </div>
        </div>
        <div className="right__header-panel">
          <span className="close__btn" onClick={closeSlideout}>
            &times;
          </span>
        </div>
      </div>
    );
  }
}

export default SalaryRangeHeader;
